// extracted by mini-css-extract-plugin
module.exports = {"box":"Registration-module--box--3Kxpl","boxText":"Registration-module--boxText--2CMr7","boxTime":"Registration-module--boxTime--2cRmc"};